(() => {
  const ACTIVE_CLASS = 'is-visible';
  const LOCKED_CLASS = 'is-locked';

  const selectors = {
    overlay: '[js-overlay]',
    popup: '[js-popup]',
    iframe: '[js-iframe]',
    closePopup: '[js-close-popup]',
  };

  class CustomButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.iframeSrc = this.getAttribute('js-iframe-src');

      this.addEventListener('click', openPopup.bind(this));
    }
  }

  function openPopup() {
    const overlay = document.querySelector(selectors.overlay);
    const popup = document.querySelector(selectors.popup);
    const iframe = document.querySelector(selectors.iframe);

    if (!popup) {
      return;
    }

    if (iframe && !iframe.src) {
      iframe.src = this.iframeSrc;
    }

    setScrollBarWidth();

    overlay.classList.add(ACTIVE_CLASS);
    popup.classList.add(ACTIVE_CLASS);
    document.body.classList.add(LOCKED_CLASS);
  }

  function closePopup() {
    const overlay = document.querySelector(selectors.overlay);
    const popup = document.querySelector(selectors.popup);

    if (!popup) {
      return;
    }

    overlay.classList.remove(ACTIVE_CLASS);
    popup.classList.remove(ACTIVE_CLASS);
    document.body.classList.remove(LOCKED_CLASS);
  }

  function setScrollBarWidth() {
    /**
     * Set actual scrollbar width as a variable.
     * - This is used to apply as `margin-right` when body is scroll locked.
     * - This prevents the entire body shifting to the right when overlay appears.
     */
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;

    document.documentElement.style.setProperty(
      '--body-scroll-bar-width',
      `${scrollbarWidth}px`
    );
  }

  window.addEventListener('DOMContentLoaded', setScrollBarWidth);

  document.body.addEventListener('click', (e) => {
    if (e.target.closest(selectors.closePopup)) {
      closePopup();
    }
  });

  if ('customElements' in window && !customElements.get('custom-button')) {
    customElements.define('custom-button', CustomButton);
  }
})();
